import { Alert } from "@material-ui/lab";

import { incrementDataRevision } from "app/store/tools/revisionSlice";

const yardStatusForm = {
	urlGET: "api/profile/carriers/:carrierId/yards/:id",
	urlDELETE: "api/profile/carriers/:carrierId/yards/:id/status/:status",
	idKey: "_id",
	triggerEvent: ["yardRevision", "dataRevision"],
	listenEvent: "yardRevision",
	header: {
		delete: { label: "Change Yard Status" },
	},
	content: {
		delete: {
			items: [
				{
					type: "message",
					builder: (item) => (
						<div>
							{item?.trucks?.length > 0 && !!item.active && (
								<Alert className="flex flex-row w-full mb-16" severity="info">
									This yard has associated trucks. If the yard is archived, trucks will be unassigned from it.
								</Alert>
							)}
							<span className="ml-5">
								Would you like to {!!item.active ? "archive" : "activate"} yard '{item.name}'?
							</span>
						</div>
					),
				},
				{
					type: "group",
					content: {
						items: [
							{ type: "action", action: "CANCEL" },
							{ type: "action", action: "DELETE", label: "Continue" },
						],
					},
				},
			],
			onFinished: (_, dispatch) => {
				dispatch(incrementDataRevision({ event: "profileRevision" }));
				if (window?.ReactNativeWebView) {
					window?.ReactNativeWebView?.postMessage(JSON.stringify({ type: "REFRESH_YARD_LIST" }));
				}
			},
		},
	},
};

export default yardStatusForm;
